//import images here
import logo from '../assets/logo.png'
import user from '../assets/user.svg'
import calculator from '../assets/calculator.png'
import discovery from '../assets/discovery.png'
import science from '../assets/science.png'
import heart from '../assets/heart.svg'
import subject from '../assets/subject.png'
import english from '../assets/english.png'
import teacher from '../assets/teacher.png'
import eventImage from '../assets/eventImage.png'
import heroImage from '../assets/heroImage.svg'
import authParent from '../assets/authParent.png'
import authStudent from '../assets/authStudent.png'
import notification from '../assets/notification.png'
import fact from '../assets/fact.png'

const Images = {
  fact,
  notification,
  authStudent,
  authParent,
  heroImage,
  logo,
  user,
  calculator,
  discovery,
  science,
  heart,
  subject,
  english,
  teacher,
  eventImage,
}

export default Images
